import ENVIRONMENT_VAR from "@/shared/models/environment/environments.var";
import JSZip from "jszip";

// Helper function to extract file extension from URL
const getExtensionFromUrl = (url: string): string => {
  try {
    // Try to get extension from the URL path
    const urlObj = new URL(url);
    const pathname = urlObj.pathname;
    const lastDotIndex = pathname.lastIndexOf(".");

    if (lastDotIndex !== -1) {
      return pathname.substring(lastDotIndex);
    }

    // If no extension found in path, try to get from query params
    const urlParam = urlObj.searchParams.get("url");
    if (urlParam) {
      const paramLastDotIndex = urlParam.lastIndexOf(".");
      if (paramLastDotIndex !== -1) {
        return urlParam.substring(paramLastDotIndex);
      }
    }

    // Default to .jpg if no extension found
    return ".jpg";
  } catch (error) {
    // If URL parsing fails, try simple string operations
    const lastDotIndex = url.lastIndexOf(".");
    if (lastDotIndex !== -1) {
      return url.substring(lastDotIndex);
    }
    return ".jpg";
  }
};

const usePropertyImagesDownload = () => {
  const downloadImages = async (images: string[], idProperty: number) => {
    try {
      const imagesURL = images.map(
        x => `${ENVIRONMENT_VAR.API_URL}/v2/download-image?url=${x}`
      );

      // Create a zip file
      const zip = new JSZip();

      // Download all images and add to zip
      const downloadPromises = imagesURL.map(async (url, index) => {
        const response = await fetch(url);
        if (!response.ok) throw new Error(`Failed to download image ${index + 1}`);

        const blob = await response.blob();
        // Extract filename from URL or use index, preserving original extension
        const urlParts = url.split("/");
        const lastPart = urlParts[urlParts.length - 1];
        const queryIndex = lastPart.indexOf("?");
        const filename =
          queryIndex !== -1
            ? lastPart.substring(0, queryIndex)
            : `image-${index + 1}${getExtensionFromUrl(url)}`;
        zip.file(filename, blob);
      });

      // Wait for all downloads to complete
      await Promise.all(downloadPromises);

      // Generate zip file
      const zipBlob = await zip.generateAsync({ type: "blob" });

      // Create download link and trigger download
      const downloadUrl = URL.createObjectURL(zipBlob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = `imagenes_propiedad_${idProperty}.zip`;
      document.body.appendChild(link);
      link.click();

      // Clean up
      document.body.removeChild(link);
      URL.revokeObjectURL(downloadUrl);

      return true;
    } catch (error) {
      console.error("Error downloading images:", error);
      return false;
    }
  };

  return { downloadImages };
};

export default usePropertyImagesDownload;
